
import axiosBase from "./common/axiosBase";
import coreConfig from "./common/coreConfig";
const { apiConfig } = coreConfig;

class JsError {

    init() {
        window.onerror = (message, source, lineno, colno, error) => {
            this.logError({ message, source, lineno, colno, stack: error?.stack || "No stack trace" });
        };

        window.onunhandledrejection = (event) => {
            this.logError({ message: event.reason?.message, stack: event.reason?.stack || "No stack trace" });
        };
    }

    async logError(errorData) {
        await axiosBase({
            api: apiConfig.endpoints.clientError,
            method: apiConfig.reqMethod.POST,
            body: JSON.stringify(errorData)
        });
    }
}

export default JsError;
